
import React from "react";
import ReactLoading from "react-loading";

const Loading = ({ type, color, height, width }) => {
    return (
        <div className="flex justify-center items-center">
            <div>
                <ReactLoading type={type} color={color} height={height} width={width} />
            </div>
        </div>
    );
};

export default Loading;


// different loaders
// import React from "react";
// import ReactLoading from "react-loading";

// const Loading = () => {
//     return (
//         <div>
//             <ReactLoading type="balls" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="bars" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="bubbles" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="cubes" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="cylon" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="spin" color="#0000FF" height={100} width={50} />
//             <ReactLoading type="spokes" color="#0000FF" height={100} width={50} />
//             <ReactLoading
//                 type="spinningBubbles"
//                 color="#0000FF"
//                 height={100}
//                 width={50}
//             />
//         </div>
//     );
// };

// export default Loading;




// import React from "react";
// import ReactLoading from "react-loading";

// export default function Loading() {
//     return (
//         <div>
//             <h2>Loading in ReactJs - GeeksforGeeks</h2>
//             <ReactLoading type="balls" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="bars" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="bubbles" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="cubes" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="cylon" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="spin" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading type="spokes" color="#0000FF"
//                 height={100} width={50} />
//             <ReactLoading
//                 type="spinningBubbles"
//                 color="#0000FF"
//                 height={100}
//                 width={50}
//             />
//         </div>
//     );
// }